module.exports = __webpack_public_path__ + "static/media/page08_two_girl.e8d06099.gif";